import { useParams, Link } from "react-router-dom";
import { Flex, Text, Breadcrumbs } from "@jsq/ds/core";
import { useFeatureFlag } from "@jsq/flags-react";
import { withClientContext } from "~/apollo/client";
import { useAppContext } from "~/contexts/appContext";
import { globalEnv } from "~/global-env";
import { useGetArenaQuery } from "~/graphql/mainHooks";
import { toGlobalId } from "~/utils/graphql-helpers";
import { isFundAccountingController } from "~/utils/userRoles";

type ArenaDetailsParams = {
  id: string;
};

export const ArenaDetail = ({ children }: { children?: React.ReactNode }) => {
  const { id = "" } = useParams<ArenaDetailsParams>();
  const { user } = useAppContext();
  const showTransactionLookupFF = useFeatureFlag("showTransactionLookup", false);
  const canAccessLookup = isFundAccountingController(user?.roles) && showTransactionLookupFF;
  const { data, loading, error } = useGetArenaQuery({
    context: withClientContext("staff"),
    variables: { id: toGlobalId("ArenaObjectType", id) },
  });

  if (loading) {
    return <Text>Loading</Text>;
  }
  if (error || !data) {
    return <Text>Error</Text>;
  }

  return (
    <Flex flexDirection="column" gap={16}>
      <Breadcrumbs
        breadcrumbs={[{ path: "/fund-accounting", name: "Managers", icon: "arrow-left" }]}
      />
      <Flex justifyContent="space-between" alignItems="center">
        <h1>{data.arena?.name}</h1>
        {canAccessLookup && id && (
          <Link
            to={`${globalEnv.fundAccountingRoute}/transaction-lookup?arenaId=${id}`}
            data-testid="arena-transaction-lookup-link"
          >
            Transaction Lookup
          </Link>
        )}
      </Flex>
      {children}
    </Flex>
  );
};
